export const STORAGE_KEY = {
  ACCESS_TOKEN: 'accessToken',
  DARK_MODE: 'darkMode',
  UNIQUE_IDENTIFIER: 'uniqueIdentifier',
  CHECKOUT_SESSION_ID: 'checkoutSessionId',
  UNITY_USER: 'unityUser',
};
